import {Component, OnDestroy, OnInit} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {DataQueryService} from '../../../classroom360/data-query/data-query.service';
import {DataQuery} from '../../../classroom360/data-query/data-query.model';
import { Subscription} from 'rxjs';
import {DataQueryField} from '../../../classroom360/data-query/data-query-field.model';
import {UserPreferencesService} from '../../user-preferences/user-preferences.service';
import {GeneralPreferences} from '../../user-preferences/general-preferences.model';
import {DataQueryFieldFilter} from '../../../classroom360/data-query/data-query-field-filter.model';
import {LoginService} from '../../../shared-modules/login/login.service';
import {LookupService} from '../../lookup/lookup.service';
import {YearService} from '../../year/year.service';
import {AdvancedFilterComponent} from '../../advanced-filter/advanced-filter.component';

@Component({
    selector: 'app-advanced-staff-search',
    templateUrl: './advanced-staff-search.component.html',
    styleUrls: ['./advanced-staff-search.component.css']
})
export class AdvancedStaffSearchComponent extends AdvancedFilterComponent implements OnInit, OnDestroy {

    // Injected Properties

    // Data Query Properties

    // Other Properties
    subscriptions: Subscription[] = [];
    generalPreferences: GeneralPreferences;
    allFilters: DataQueryFieldFilter[] = [];

    // Class Functions
    constructor(
        dialogBox: MatDialogRef<AdvancedStaffSearchComponent>,
        dataQueryService: DataQueryService,
        loginService: LoginService,
        lookupService: LookupService,
        yearService: YearService,
        userPreferencesService: UserPreferencesService,
        dialog: MatDialog
    ) {
        super(dataQueryService, userPreferencesService, loginService, dialogBox, lookupService, yearService, dialog);
        this.fieldsWithoutFilters = [
            'Staff_ID'
        ];
    }

    // Overridden Methods
    initialize() {
        // POST: sets this up as staff search
        if (!this.dataQueryService.isStaffSearch) {
            this.dataQueryService.currentQuery = new DataQuery();
            this.dataQueryService.isStaffSearch = true;
        }
    }

    setValueSwitch(field: DataQueryField, filter: DataQueryFieldFilter, updateUsing: boolean) {
        // POST: sets the filter's values (operator, value, and group)

        // Updating based on grid filters (these do not take priority, so they come first)
        switch (field.Alias) {
            // TODO
            default:
                break;
        }

        // Updating based on search criteria (these take priority, so they come last)
        switch (field.FieldName) {
            // TODO
            default:
                break;
        }
    }

    setFilterPropertiesSwitch(field: DataQueryField, filter: DataQueryFieldFilter) {
        // POST: sets the filter's properties for staff search
        filter.Operator = '=';
        filter.Value = '';
        filter.Value2 = '';
        filter.Group = 'A';
        filter.DisplayMenu = false;
        filter.UseCurrentDate1 = false;
        filter.UseCurrentDate2 = false;
        filter.UseFilterForStudentSearch = false;
        filter.UseFilterForCourseSearch = false;
        filter.UseFilterForStaffSearch = false;
        filter.IsStudentFilter = false;
        filter.StudentFilterId = 0;
        filter.ApplyToAll = false;

        // Setting specific values for certain fields
        if (field.FieldName == 'PrimaryJob') {
            filter.Value = 'Y';
            filter.disableEdit = true;
            filter.UseFilterForStaffSearch = true;
        }
    }
}
